import axios, { AxiosRequestConfig, AxiosInstance } from "axios";
import { User } from "shared/store/auth/types";
import { ServerSideConfig } from "shared/bootstrap/types";
import { LocaleMessages } from "vue-i18n";

let client = axios.create();

export default (): AxiosInstance => client;

export const setupClient = (config: AxiosRequestConfig): void => {
  client = axios.create(config);
};

export interface GlobalInfo {
  logged_in: boolean;
  user_id: string;
}

export const getGlobalInfo = async (): Promise<GlobalInfo> => {
  const res = await client.get<GlobalInfo>(`api/global-info`);
  return res.data;
};

export const getProfile = async (): Promise<User> => {
  const res = await client.get<User>(`api/base/auth/profile`);
  return res.data;
};

export const getServerSideConfig = async (): Promise<ServerSideConfig> => {
  const res = await client.get<ServerSideConfig>(`api/base/frontend-config`);
  return res.data;
};

export const getTranslations = async (
  lang: string
): Promise<LocaleMessages> => {
  const res = await client.get<LocaleMessages>(`api/base/translations/` + lang);
  return res.data;
};
